/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, NavParams, NavController, ViewController, PopoverController, ToastController, AlertController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { SessionProvider } from '../../../providers/session';
import { MainProcessProvider } from '../../../providers/processes/main';
import { Account_UserProfileStore } from './userProfile.store';

@Component({
  selector: 'page-account-userProfile',
  templateUrl: 'userProfile.html',
})
export class Account_UserProfilePage {
  @ViewChild(Content) private content: Content;
  private isBuzy = false;
  private isProcessing = false;
  constructor(
    // *** System
    private navParams: NavParams,
    private navCtrl: NavController,
    private viewCtrl: ViewController,
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private mainProcess: MainProcessProvider,
    private store: Account_UserProfileStore) {
  }

  // *** Evénement de chargement
  ngOnInit() {
    try {
      this.isBuzy = true;
      this.store.load().then(
        (succeed) => {
          this.isBuzy = false;
          this.content.resize();
          this.content.scrollToTop();
        },
        (error) => { this.isBuzy = false; }
      );
    }
    catch (error) {
      this.isBuzy = false;
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Evénement de clôture
  ionViewWillUnload() {
    try {
      this.store.reset();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Recharger les données
  private _doRefresh(refresher) {
    try {
      this.isBuzy = true;
      this.store.load(true).then(
        (result) => {
          refresher.complete();
          this.content.resize();
          this.isBuzy = false;
        },
        (error) => {
          refresher.complete();
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      refresher.complete();
      this.isBuzy = false;
    }
  }

  // *** Modifier le profil utilisateur
  private _update() {
    try {
      this.isBuzy = true;
      this.mainProcess.updateUserProfile(this.store.activeUserProfile).then(
        (data) => {
          let alert = this.alertCtrl.create({
            title: data['IsUpdated'] ? '' : 'Erreur!',
            subTitle: data['Messages'] ? data['Messages'].join('<br/>') : this.globals.MSG_UNKNOWN_ERROR,
            buttons: ['OK']
          });
          alert.present();
          this.isBuzy = false;
        },
        (error) => {
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }

  // *** Changer le mot de passe utilisateur
  private _changePassword(oldPassword: string, newPassword: string) {
    try {
      this.isBuzy = true;
      this.mainProcess.changePassword(oldPassword, newPassword).then(
        (data) => {
          let alert = this.alertCtrl.create({
            title: data['IsUpdated'] ? '' : 'Erreur!',
            subTitle: data['Messages'] ? data['Messages'].join('<br/>') : this.globals.MSG_UNKNOWN_ERROR,
            buttons: ['OK']
          });
          alert.present();
          this.isBuzy = false;
        },
        (error) => {
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/userProfile/userProfile.ts